import React, {useEffect, useContext} from 'react';
import { Box, Snackbar, Stack, TableCell, TextField, Typography, Button, IconButton, Dialog, Backdrop, CircularProgress } from '@mui/material';
import {Context} from '../App';
import SorTableCheckable from '../components/ui/sortable-checkable';
import { CurrencyExchangeRounded, DeleteForever, Edit, InfoOutlined, Add } from '@mui/icons-material';
import AppLayout from '../components/layout/AppLayout';
import CmdRefund from '../components/forms/CmdRefund';
import CmdDelete from '../components/forms/CmdDelete';
import CmdInfo from '../components/ui/CmdInfo';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import CmdEditForm from '../components/forms/CmdEditForm';
import CmdAddForm from '../components/forms/CmdAddForm';

export default function Commandes() {
    const navigate = useNavigate();
    const {setIsConnected} = useContext(Context)
    const user = JSON.parse(sessionStorage.getItem('user'))
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [commandes, setCommandes] = React.useState([]);
    const [commande, setCommande] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');
    const [statutFilter, setStatutFilter] = React.useState('');

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackMsg, setSnackMsg] = React.useState('');

    const table = [
        {header: "Date", sortable: true, sortBy:(el)=>new Date(el.createdAt).getTime(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'50px'}}>{moment(row.createdAt).format('DD/MM/yyyy')}</TableCell>},
        {header: "N°", sortable: true, sortBy:(el)=>el.num, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'100px'}}>{row.num}</TableCell>},
        {header: "N° reçu", sortable: true, sortBy:(el)=>el.recuNum, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'170px'}}>{row.recuNum}</TableCell>},
        {header: "Statut", sortable: true, sortBy:(el)=>el.statut.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'110px'}}>{row.statut}</TableCell>},
        {header: "Client", sortable: true, sortBy:(el)=>(el.user?.nom+' '+el.user?.prenom).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{!!row.user?(row.user?.nom+' '+row.user?.prenom): ''}</TableCell>},
        {header: "Articles", sortable: true, sortBy:(el)=>el.items.length, row: (row, index)=><TableCell key={index} style={{textAlign:'center'}}>{row.items.length}</TableCell>},
        {header: "Ref paiement", sortable: true, sortBy:(el)=>el.payments.find(p=> p.status==='Payée')?.txCode, row: (row, index)=><TableCell key={index} sx={{textAlign:'center'}}>{row.payments.find(p=> p.status==='Payée')?.txCode}</TableCell>},
        {header: "Montant total", sortable: true, sortBy:(el)=>el.items.reduce((tt, item)=>tt+(item.id?.price || 0),0), row: (row, index)=><TableCell key={index} style={{minWidth:'50px', textAlign:'center'}}>{!!row.items.some(item=>!!item.id?.price) ? (row.items.reduce((tt, item)=>tt+(item.id?.price || 0),0)?.toFixed(2)+' €') :''}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="éditer" onClick={()=>{setCommande(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
            <IconButton aria-label="rembourser" disabled={row.statut!=='Payée'} onClick={()=>{setCommande(row); manage_dialog(true, 'refund')}}><CurrencyExchangeRounded fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" disabled={row.statut!=='En attente'} onClick={()=>{setCommande(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="informations complémentaires" onClick={()=>{setCommande(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.num+' '+item.recuNum+' '+item.payments.find(p=> p.status==='Payée')?.txCode+' '+item.user?.nom+' '+item.user?.prenom
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setCommande()
        }
    }

    function manage_snackbar(status, msg='') {
        setOpenSnackbar(status)
        setSnackMsg(msg)
        if(!status) {
            setSnackMsg('')
        }
    }

    useEffect(() => {
        if (!user || user.role === 'user') {
            sessionStorage.clear();
            setIsConnected(false);
        } else if (user.role !== 'super admin') {
            navigate('/')
        }
    }, [user])

    useEffect(() => {
        const query = new URLSearchParams({}).toString();

        fetch(process.env.REACT_APP_API_URL.concat('/adm/commandes?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    json.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by createdAt descending
                    setCommandes(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching commandes:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <AppLayout collapse>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2, overflowX:'scroll'}}>
                <Typography variant='h2' marginBlock={3} align='center'>Gestionnaire de commandes</Typography>

                <Button variant='outlined' startIcon={<Add/>} sx={{alignSelf:'end', mb:{sx:2, sm:4}}} onClick={()=>manage_dialog(true, 'add')}>Nouvelle commande</Button>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher une commande ..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    <TextField select label="Filtre" value={statutFilter} onChange={(e)=>setStatutFilter(e.target.value)} size="small" sx={{minWidth:'120px', width:'20%'}} slotProps={{ select: { native: true }, inputLabel:{shrink: true} }}>
                        <option value="">Tous</option>
                        <option value="En attente">En attente</option>
                        <option value="Payée">Payée</option>
                        <option value="Annulée">Annulée</option>
                        <option value="Remboursée">Remboursée</option>
                    </TextField>
                </Stack>

                <SorTableCheckable {...{data:commandes.filter(reg=>searchFilter(reg, searchInput)&&(statutFilter==='' || reg.statut === statutFilter)),table, selectItems, setItems, rowsPerPage:100, rowsPerPageOptions:[50, 100, 300]}}/>
            </Box>

            <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:['edit', 'add'].includes(action) ? 'md' : 'sm', fullWidth:true}}>
                {action === 'refund' && <CmdRefund {...{commande, close:()=>manage_dialog(false), manage_snackbar, setCommandes: cmd => setCommandes(old=> old.map(c => c._id === cmd._id ? cmd : c))}}/>}
                {action === 'delete' && <CmdDelete {...{commande, close:()=>manage_dialog(false), manage_snackbar, updateCommandes: () => setCommandes(old=> old.filter(c => c._id !== commande._id))}}/>}
                {action === 'info' && <CmdInfo {...{commande, close:()=>manage_dialog(false)}}/>}
                {action === 'edit' && <CmdEditForm {...{commande, close:()=>manage_dialog(false), manage_snackbar, setCommande: cmd => setCommandes(old=> old.map(c => c._id === cmd._id ? cmd : c))}}/>}
                {action === 'add' && <CmdAddForm {...{close:()=>manage_dialog(false), manage_snackbar, addCommande: cmd => setCommandes(old=> [cmd, ...old])}}/>}
            </Dialog>

            <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={()=> manage_snackbar(false)} message={snackMsg} />

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </AppLayout>
    )
}

